import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#E4E4DE]">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 grid gap-12 md:grid-cols-3">
      <div>
        <Logo />
        <p className="mt-5 max-w-xs text-sm text-zinc-500 leading-relaxed">
          Tactical heavyweight streetwear. 280GSM organic cotton, archival prints,
          zero-waste production. Small runs, never restocked twice.
        </p>
      </div>
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#4D7C0F]">Navigate</p>
        <ul className="mt-5 space-y-3">
          {[
            { to: "/shop", label: "Shop all tees", id: "footer-shop-link" },
            { to: "/about", label: "About the studio", id: "footer-about-link" },
            { to: "/contact", label: "Contact us", id: "footer-contact-link" },
            { to: "/admin", label: "Store admin", id: "footer-admin-link" },
          ].map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={l.id}
                className="font-mono text-xs uppercase tracking-widest text-zinc-500 hover:text-[#4D7C0F] transition-colors"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#4D7C0F]">Studio</p>
        <ul className="mt-5 space-y-3 font-mono text-xs uppercase tracking-widest text-zinc-500">
          <li>Unit 7, Concrete Works</li>
          <li>Antwerp, BE 2000</li>
          <li>studio@maraboudesign.com</li>
          <li>Mon–Fri / 09:00–18:00 CET</li>
        </ul>
      </div>
    </div>
    <div className="overflow-hidden border-t border-[#E4E4DE] py-4">
      <p className="text-center font-display text-[16vw] md:text-[10vw] font-extrabold uppercase leading-none tracking-tighter text-outline select-none">
        Marabou
      </p>
    </div>
    <div className="border-t border-[#E4E4DE] py-5 text-center font-mono text-[10px] uppercase tracking-widest text-zinc-600">
      © 2026 Marabou Design — All garments heavyweight
    </div>
  </footer>
);
